const fonts = {
    heading: "CamberBold",
    subHeading: "CamberBold",
}

export default fonts
